import { render, staticRenderFns } from "./PersistTipoPessoaRecebedorView.vue?vue&type=template&id=9bea1e60&"
import script from "./PersistTipoPessoaRecebedorView.vue?vue&type=script&lang=ts&"
export * from "./PersistTipoPessoaRecebedorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports